import { render, staticRenderFns } from "./BillingAffiliationTable.vue?vue&type=template&id=0a49ab76"
import script from "./BillingAffiliationTable.vue?vue&type=script&lang=js"
export * from "./BillingAffiliationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports